import { useState } from "react";
import { Check, ChevronsUpDown, X } from "lucide-react";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "../ui/command";
import { cn } from "../../lib/utils";

// Combobox multi-select con búsqueda — usado para catálogos largos de Airtable
// (Especialidad ~190, Event Leads ~38, Batch ~13) donde un <Select> normal es
// inmanejable. Petición feedback Ecosistema/Partners 2026-08-31.
export function MultiSelectCombobox({ options = [], value = [], onChange, placeholder = "Seleccionar...", testId }) {
  const [open, setOpen] = useState(false);
  const toggle = (opt) => {
    if (value.includes(opt)) onChange(value.filter((v) => v !== opt));
    else onChange([...value, opt]);
  };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="w-full justify-between font-normal h-auto min-h-9 py-1.5"
          data-testid={testId}
        >
          <div className="flex flex-wrap gap-1 flex-1 text-left min-w-0 overflow-hidden">
            {value.length === 0 && <span className="text-muted-foreground">{placeholder}</span>}
            {value.length === 1 && (
              <Badge variant="secondary" className="text-xs gap-1 pr-1 max-w-full">
                <span className="truncate">{value[0]}</span>
                <X
                  className="w-3 h-3 cursor-pointer shrink-0"
                  onClick={(e) => { e.stopPropagation(); toggle(value[0]); }}
                />
              </Badge>
            )}
            {value.length > 1 && (
              <Badge variant="secondary" className="text-xs gap-1 pr-1" data-testid={testId ? `${testId}-count-badge` : undefined}>
                {value.length} seleccionados
                <X
                  className="w-3 h-3 cursor-pointer shrink-0"
                  onClick={(e) => { e.stopPropagation(); onChange([]); }}
                />
              </Badge>
            )}
          </div>
          <ChevronsUpDown className="w-4 h-4 shrink-0 opacity-50 ml-2" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start">
        <Command>
          <CommandInput placeholder="Buscar..." />
          <CommandList>
            <CommandEmpty>Sin resultados.</CommandEmpty>
            <CommandGroup className="max-h-64 overflow-y-auto">
              {options.map((opt) => (
                <CommandItem key={opt} value={opt} onSelect={() => toggle(opt)}>
                  <Check className={cn("mr-2 h-4 w-4", value.includes(opt) ? "opacity-100" : "opacity-0")} />
                  {opt}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
